// extracted by mini-css-extract-plugin
export default {"wrapperClass":"LoadedMap_wrapperClass__YzNtn","contentClass":"LoadedMap_contentClass__IgrLc"};